import { render, staticRenderFns } from "./CardConfirma.vue?vue&type=template&id=393a53a3"
import script from "./CardConfirma.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardConfirma.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports